import React from 'react';
import PropTypes from 'prop-types';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { Pagination } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

function NewsPagination({ current, last, onPageChange }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isLast = !!current && !!last && current === last;
  const totalPages = last ? last + 1 : last; // add pseudo-page for archive

  const handleChange = (page) => {
    // If user moves beyond the real last page, go to archive
    if (last && page > last) {
      navigate(routes.newsArchive);
      return;
    }
    onPageChange(page);
  };

  const itemRender = (page, type, originalElement) => {
    if (type === 'prev') {
      return (
        <Link to={`${routes.homePage}?page=${page}`}>
          <LeftOutlined
            style={{ marginRight: '2px', verticalAlign: 'middle' }}
          />
        </Link>
      );
    }
    if (type === 'next') {
      // On the last valid page, clicking next should open archive
      if (isLast) {
        return (
          <Link
            to={routes.newsArchive}
            title={t('Archív')}
            aria-label={t('Archív')}
          >
            <RightOutlined
              style={{ marginLeft: '2px', verticalAlign: 'middle' }}
            />
          </Link>
        );
      }
      return (
        <Link to={`${routes.homePage}?page=${page}`}>
          <RightOutlined
            style={{ marginLeft: '2px', verticalAlign: 'middle' }}
          />
        </Link>
      );
    }
    if (type === 'page' && last && page === last + 1) {
      // Hide the pseudo-page for archive from visible pagination items
      return null;
    }
    return originalElement;
  };

  return (
    <div className="hp-pagination-container">
      {current && last && (
        <Pagination
          current={current}
          total={totalPages}
          defaultCurrent={1}
          defaultPageSize={1}
          showSizeChanger={false}
          onChange={handleChange}
          itemRender={itemRender}
        />
      )}
    </div>
  );
}

NewsPagination.propTypes = {
  first: PropTypes.number,
  current: PropTypes.number,
  last: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
};

export default NewsPagination;
